<template>
  <section class="flex block__slideout commercial">
    <b-row class="block__commercialDetails">
      <!-- ENTETE -->
      <div class="mobile">
        <div class="link">
          <button class="bt btn-back" @click="goBack()">
              <font-awesome-icon :icon="['far', 'angle-left']"/>
          </button>
          <PuSkeleton :loading="isLoading" :count="1" width='100%' height="30px">
          </PuSkeleton>
          <h3 v-if="!isLoading">{{observedUser.fullName}}</h3>
        </div>
        <div class="sep"></div>
      </div>
      <!-- ENTETE -->


      <!-- //CONTENT -->
      <!-- CONTENT -->

        <div class="column-middle-parent">
          <div class="desktop">
            <div class="hearder-commercial d-flex justify-content-between">
              <div><a v-on:click="$router.push('/commerciaux')" style="cursor: pointer"><b>Commerciaux</b></a> > <b>{{observedUser.fullName}}</b> <span v-if="!isLoading">(Dernière connexion : {{ connectionsInfos.date ? connectionsInfos.date : '-'}})</span></div>
              <div v-on:click="addFavoriteCommercial()">
                <span v-if="observedUser.isFavorite"><i class="fas fa-star pr-2"></i></span><span v-else><i class="far fa-star pr-2"></i></span> Suivre ce commercial
              </div>
            </div>
          </div>
          <div class="mobile ml-3 mr-3">
            <div class="hearder-commercial">
              <div class="mb-2"><a v-on:click="$router.push('/commerciaux')" style="cursor: pointer"><b>Commerciaux</b></a> > <b>{{observedUser.fullName}}</b> <span v-if="!isLoading">(Dernière connexion : {{ connectionsInfos.date ? connectionsInfos.date : '-'}})</span></div>
              <div v-on:click="addFavoriteCommercial()" class="text-right">
                <span v-if="observedUser.isFavorite"><i class="fas fa-star pr-2"></i></span><span v-else><i class="far fa-star pr-2"></i></span> Suivre ce commercial
              </div>
            </div>
          </div>
          <div class="sep desktop"></div>
          <div>
            <b-tabs class="p-0" content-class="mt-3 p-3" v-if="showAll">
              <b-tab title="Résultats" active>
                <b-row>
                  <b-col sm="12" class="d-flex justify-content-end">
                    <div class="desktop d-flex">
                      <div class="mb-3 mr-3" v-if="dates && dates.length > 0">
                        <p><b>Date :</b></p>
                        <div class="select__wrapper">
                          <font-awesome-icon :icon="['far', 'chevron-down']" />
                          <b-form-select :options="dates" v-model='selectedDateId' class="select">
                          </b-form-select>
                        </div>
                      </div>
                      <div v-if="codePtf && codePtf.length > 0">
                        <p><b>Code portefeuille :</b></p>
                        <div class="select__wrapper">
                          <font-awesome-icon :icon="['far', 'chevron-down']" />
                          <b-form-select v-model="selected" :options="codePtf" class="select">
                          </b-form-select>
                        </div>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <div>
                  <b-row>
                    <b-col sm="12">
                      <Stack height="1.5rem" class="mobile"></Stack>
                      <b-row class="d-flex ion-align-items-baseline mt-4 mb-3">
                        <b-col sm="12" class="d-flex align-items-baseline">
                          <div class="subHeader mb-2">
                            <div class="title">Indicateur de suivi national</div>
                          </div>
                        </b-col>
                      </b-row>

                      <b-row v-if="isLoading">
                        <b-col sm="12">
                          <PuSkeleton :loading="isLoading" :count="4" width="100%" />
                        </b-col>
                      </b-row>

                      <b-row class="bg-white card-big personal-indicator-part m-0 p-0 mt-3" v-if="this.personalIndicators.national && personalIndicators.national.total && !isLoading">
                        <IndicatorsTreeTable
                            :tree="nationalTree"
                            :showCheckboxes="false"
                            @show-graph="showGraphModal"
                        />
                      </b-row>
                      <b-row v-if="!isLoading && (!personalIndicators.national || personalIndicators.national.length === 0)">
                        <b-col sm="12">
                          <b-row class="bg-white card-big m-1 p-5 no-indicator">
                            <b-col sm="12" class="d-flex justify-content-between align-items-center no-indicator flex-column">
                              <i class="far fa-chart-line"></i>
                              <h1>Aucun indicateur de suivi national</h1>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col sm="12">
                      <Stack height="1.5rem" class="mobile"></Stack>
                      <b-row class="d-flex ion-align-items-baseline mt-4 mb-3">
                        <b-col sm="6" class="d-flex align-items-baseline">
                          <div class="subHeader mb-2">
                            <div class="title">Indicateurs de suivi personnel</div>
                          </div>
                        </b-col>
                      </b-row>

                      <b-row v-if="isLoading">
                        <b-col sm="12">
                          <PuSkeleton :loading="isLoading" :count="4" width="100%" />
                        </b-col>
                      </b-row>

                      <b-row class="bg-white card-big m-1 p-5 no-indicator" v-if="!isLoading && (!personalIndicators.personal || personalIndicators.personal.length === 0)">
                        <b-col sm="12" class="d-flex justify-content-between align-items-center no-indicator flex-column">
                          <i class="far fa-chart-line"></i>
                          <h1>Aucun indicateur suivis</h1>
                          <h2>Parcourez les indicateurs et suivez les chiffres</h2>
                        </b-col>
                      </b-row>
                      <b-row
                          class="bg-white card-big personal-indicator-part m-0 p-0 mt-3"
                          v-if="!isLoading && personalIndicators && personalIndicators.personal && personalIndicators.personal.total"
                      >
                        <IndicatorsTreeTable
                            :tree="personalTree"
                            :showCheckboxes="false"
                            @show-graph="showGraphModal"
                        />
                      </b-row>
                    </b-col>
                  </b-row>
                </div>
              </b-tab>

              <b-tab title="PRO" v-if="haveAccess(ApplicationsAccessEnum.APP_PRO_OF_OTHER)">
                <div class="pro_part">
                  <div class="content__pro">
                    <!-- //TITLE DESKTOP -->
                    <div class="desktop">
                      <h1>PRO</h1>
                      <div class="select__wrapper">
                        <font-awesome-icon :icon="['far', 'chevron-down']" />
                        <b-form-select v-model="selectedPro" :options="prosDropDown" class="select">
                        </b-form-select>
                      </div>
                      <div class="pro_buttons">
                        <a v-if="downloadSignedProLink" :href="downloadSignedProLink" target="_blank" class="bt">
                          Pro signé <i class="fas fa-file-pdf"></i>
                        </a>
                        <a v-if="downloadLink" :href="downloadLink" target="_blank" class="bt">
                          CGV signé <i class="fas fa-file-pdf"></i>
                        </a>
                        <div v-if="proData.state === 'validate' && proDates.length > 0" style="display: flex; align-items: center;">
                          <p><b>Dates :</b></p>
                          <div class="select__wrapper date">
                            <font-awesome-icon :icon="['far', 'chevron-down']" />
                            <b-form-select v-model="selectedProDate" :options="proDates" class="select">
                            </b-form-select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- //TITLE DESKTOP -->
                  </div>

                  <div class="download-pro" v-if="proData.state === 'wait_sign'">
                    <p>Vous avez validé vos pro, Bravo ! <span style="color: #F08F2E; cursor: pointer" v-on:click="downloadUserProForSign()">Télécharger, signer vos PRO <i class="pr-2 fas fa-file-pdf"></i></span>et déposer les ci-dessous.</p>
                    <div class="dropzone_button">
                      <vue-dropzone ref="myVueDropzone" :useCustomSlot="true" id="dropzone" :options="dropzoneOptions" v-on:vdropzone-success="dropzoneSuccess" v-on:vdropzone-error="dropzoneError">
                        <div class="dropzone-custom-content">
                          <div class="subtitle"><i class="fas fa-file-pdf"></i> Téléverser vos PRO signé</div>
                        </div>
                      </vue-dropzone>
                      <b-button
                          @click="sendSignedPro()"
                          class="btn-download"
                          :class="{disabled:isLoading}"
                      >
                        Envoyer
                      </b-button>
                    </div>
                  </div>

                  <div class="waiting-validate-pro" v-if="proData.state === 'waiting'">
                    <p>Les PRO ont bien été envoyées et sont en attente de validation par l’administrateur. Une fois valider vous pourrez voir les résultats !</p>
                  </div>

                  <div class="pro-validate-no-result" v-if="proData.state === 'validate' && proDates.length === 0">
                    <p>Les PRO ont bien été validées. Vos premiers résultats seront visibles d'ici 7 jours.</p>
                  </div>

                  <div v-if="proData.state === 'validate' && proDates.length > 0" style="padding-bottom: 100px">
                    <wrapper-p-r-o-list  v-for="(value,index) in proData.userProUserProObjectives" :key="`${index}-pro`"
                                         class="mb-4"
                                         :lists="value.userProObjectives"
                                         :name="value.proCategory.name"
                                         :isLoad.sync = "isLoading"
                    />

                    <div class="block__totalPoints" style="width: 72%;" v-if="Object.values(proData).length > 0">
                      <p class="title">Estimation de prime</p>
                      <p class="number">
                        <PuSkeleton :loading="isLoading" :count="1" width='60px'>
                          {{ getTotalPrime }}
                        </PuSkeleton>
                      </p>
                    </div>
                  </div>
                  <div v-else>
                    <wrapper-p-r-o-draft  v-for="(value,index) in proData.userProUserProObjectives" :key="`${index}-pro`"
                                          class="mb-4"
                                          :lists="value.userProObjectives"
                                          :agents="agentsDropDown"
                                          :name="value.proCategory.name"
                                          :isLoad.sync = "isLoading"
                                          :userProUserProObjectivesIndex = "index"
                                          :readonly = "proData.state === 'wait_sign' || proData.state === 'waiting' || proData.state === 'validate'"
                    />
                  </div>


                  <div v-if="prosDropDown.length === 0 || !proData" class="text-center">
                    <PuSkeleton :loading="isLoading" :count="1" width='160px'>
                      Aucune données PRO
                    </PuSkeleton>
                  </div>

                  <div class="pro-btn" v-if="proData.state === 'draft' || proData.state === 'refused'">
                    <b-button
                        @click="saveUserPro(false)"
                        class="btn-outline"
                        :class="{disabled:isLoading}"
                    >
                      Enregistrer
                    </b-button>

                    <b-button
                        @click="showModal()"
                        ref="btnShow"
                        class="btn-primary"
                        :class="{disabled:isLoading}"
                    >
                      Valider pour signature
                    </b-button>
                  </div>
                  <validateForSignProModal
                      @send="handleModal"
                  >
                  </validateForSignProModal>

                  <send-signed-pro-modal
                      @send="handleSignedProModal"
                  >
                  </send-signed-pro-modal>

                </div>

              </b-tab>
            </b-tabs>

          </div>


          <!-- //SEP -->
          <div class="sep desktop" style="margin-left: 1.25rem;margin-right: 1.25rem; width: auto"></div>
          <!-- //SEP -->

          <graph-modal />

          <!-- //CARD SIMPLE DESKTOP -->
          <transition name="slide">
            <keep-alive>
              <router-view class="transition"></router-view>
            </keep-alive>
          </transition>

          <transition name="modal">
            <keep-alive>
              <router-view name="helper" class="myModal"></router-view>
            </keep-alive>
          </transition>
        </div>

      <!-- CONTENT -->
    <!-- /////////////// WRAPPER -->
    </b-row>
    <!-- <Footer/> -->

  </section>
</template>


<script>
import { mapGetters } from 'vuex'
import ParentMixin from '../../ParentMixin'
import CatMixin from '../../category/CatMixin'
import Stack from '../../../module/stack/Stack';
import ApiService from '../../../../services/ApiService'
import WrapperPROList from "@/components/module/wrapper/wrapperPROList";
import WrapperPRODraft from "@/components/module/wrapper/wrapperPRODraft.vue";
import vueDropzone from "vue2-dropzone";
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import sendSignedProModal from "@/components/module/modal/SendSignedProModal.vue";
import validateForSignProModal from "@/components/module/modal/ValidateForSignProModal.vue";
import ApiAuthenticationService from "@/services/ApiAuthenticationService";
import moment from 'moment'
import {ApplicationsAccessEnum} from "@/services/Enum/ApplicationsAccessEnum";
import IndicatorsTreeTable from "@/components/module/tabs/IndicatorsTreeTable.vue";
import GraphModal from "@/components/module/modal/GraphModal.vue";

export default {
  name:"commercial",
    components:{
      GraphModal,
      IndicatorsTreeTable,
      validateForSignProModal,
      sendSignedProModal,
      vueDropzone,
      WrapperPRODraft,
      WrapperPROList,
      Stack
    },
    mixins: [
      ParentMixin,
      CatMixin
    ],
    computed: {
      nationalTree() {
        return this.buildTree('national');
      },
      personalTree() {
        return this.buildTree('personal');
      },
      ApplicationsAccessEnum() {
        return ApplicationsAccessEnum
      },
      moment() {
        return moment;
      },
      ...mapGetters([
        'getCurrentCodePtf',
        'getCodePtf'
      ]),
      getTotalPrime(){
        let cpt = 0;
        for (let data of this.proData.userProUserProObjectives){
          cpt += data.userProObjectives
              .map( v => v.userProTrackingNumbers[0] ? v.userProTrackingNumbers[0].currentPrime : 0 )
              .reduce( (sum, current) => sum + current, 0 );
        }
        return Math.round(Math.floor(cpt)).toLocaleString();
      },
    },
    data () {
      return {
        currentUser: {},
        observedUser: {},
        isLoading:true,
        dates: [],
        codePtf: [],
        selected: null,
        personalIndicators: [],
        selectedDateId: null,
        selectedDate: null,
        connectionsInfos: [],
        downloadSignedProLink: null,
        currentId: '',
        proData: [],
        showAll: true,
        downloadLink: null,
        proList: [],
        selectedPro: null,
        proDates: [],
        selectedProDate: null,
        prosDropDown: [],
        agentsDropDown: [],
        dropzoneOptions: {
          url: process.env.VUE_APP_API_URI + '/api/media',
          maxFilesize: 20,
          acceptedFiles: 'application/pdf',
          addRemoveLinks: true,
          maxFiles: 1,
          withCredentials: false,
          dictRemoveFile: 'Supprimer',
          dictCancelUpload: '',
          headers : {
            Authorization: 'Bearer ' + ApiAuthenticationService.getAccessToken(),
            'Cache-Control': null,
            'X-Requested-With': null,
            Accept: null,
          }
        }
      }
    },
    created (){
      this.currentUser = ApiAuthenticationService.getCurrentUser();
      this.isMobile ? this.$store.dispatch('showHeader',false):'';
      this.currentId = this.$route.params.userId;

      ApiService.getParcourirApi().getDates().then((data) => {
        this.dates = data.data;
        this.dates = this.dates.map((element) => { return {value: element.id, text: element.text, date: element.value} })
        if (this.dates.length > 0) {
          this.selectedDateId = this.dates[0].value;
          this.selectedDate = this.dates[0].date;
        }

        this.setData().then(() => this.isLoading = false);
      });
    },
    activated() {
      this.personalIndicators = {};
      let promises = [];

      promises.push(this.getProList().then(() => {
        if (this.selectedPro) {
          this.getProDates().then(() =>{
            this.getProDetails();
          })
        }
      }));

      promises.push(this.setData());

      Promise.all(promises).then(() => this.isLoading = false);
    },
  methods : {
    showGraphModal(data) {
      this.$store.dispatch('setGraphCriteria', {
        key: data.critere.key,
        name: data.critere.label,
        userId: data.objectData?.id,
        userName: data.objectData?.name,
        codePtf: data.objectData?.codePtf
      });
      this.$root.$emit('bv::show::modal', 'graph-modal', '#btnShow');
    },
    buildTree(scope) {
      const raw = this.personalIndicators;
      if (!raw || !raw.infos){
        return [];
      }

      const infos = raw.infos || {};

      let total = (raw[scope] && raw[scope].total) ? raw[scope].total : {};
      if (this.selected && raw[scope] && raw[scope][this.selected]) {
        total = raw[scope][this.selected];
      }

      const parents = new Map();

      Object.entries(infos).forEach(([criteriaKey, meta]) => {
        const parentLabel = meta.parentCategory || 'Autres';
        const categoryLabel = meta.category || 'Sans catégorie';

        const values = this.extractABC(total, criteriaKey);
        if (!values) {
          return
        }

        const parentNode = this.getOrCreateParent(parents, parentLabel);

        parentNode.children.push({
          id: `${scope}_crit_${criteriaKey}`,
          category: categoryLabel,
          key: criteriaKey,
          label: meta.label || criteriaKey,
          reverse: !!meta.reverse,
          refreshFrequency: meta.refreshFrequency,
          rank: meta.rank?.[this.selected] ?? meta.rank,

          moisN: values.c != null ? Math.round(Number(values.c)).toLocaleString() : '-',
          moisN1: values.b != null ? Math.round(Number(values.b)).toLocaleString() : '-',
          diff: values.diff != null ? Math.round(Number(values.diff)).toLocaleString() : '-',
          diffRaw: values.diff,

          nationalValue: (meta.nationalValue != null) ? Math.round(Number(meta.nationalValue)).toLocaleString() : '-',
          totalN1: values.a != null ? Math.round(Number(values.a)).toLocaleString() : '-',

          classement: raw?.classement?.[criteriaKey]?.[`${criteriaKey}_c`] ?? [],
        });
      });

      const sortByLabel = (a, b) => (a.label || '').localeCompare(b.label || '', 'fr', { sensitivity: 'base' });
      const sortByCategoryAndLabel = (a, b) => {
        const catA = (a.category || '').trim();
        const catB = (b.category || '').trim();

        const byCategory = catA.localeCompare(catB, 'fr', { sensitivity: 'base' });
        if (byCategory !== 0) {
          return byCategory;
        }

        const labelA = (a.label || '').trim();
        const labelB = (b.label || '').trim();

        return labelA.localeCompare(labelB, 'fr', { sensitivity: 'base' });
      }

      const result = Array.from(parents.values()).sort(sortByLabel);
      result.forEach((p) => p.children.sort(sortByCategoryAndLabel));
      return result;
    },
    haveAccess(accessType, current = true) {
      if (current) {
        if (this.currentUser.applicationsAccess) {
          if (typeof this.currentUser.applicationsAccess === 'object') {
            return Object.values(this.currentUser.applicationsAccess).includes(accessType);
          }
          return this.currentUser.applicationsAccess.includes(accessType);
        }
      } else {
        if (this.observedUser.applicationsAccess) {
          if (typeof this.observedUser.applicationsAccess === 'object') {
            return Object.values(this.observedUser.applicationsAccess).includes(accessType);
          }
          return this.observedUser.applicationsAccess.includes(accessType);
        }
      }

      return false;
    },
    async getProDetails() {
      this.proData = [];
      if (this.proDates.length > 0 && this.selectedProDate === null) {
        this.selectedProDate = this.proDates[0]['value'];
      }
      await ApiService.getProApi().getDetail(
          this.selectedPro.id,
          this.$route.params.userId,
          this.selectedProDate
      ).then((data) => {
        this.proData = data.data;
        if (this.proData.signedPro) {
          this.downloadSignedProLink = ApiService.getMediaApi().get(this.proData.signedPro.id);
        } else {
          this.downloadSignedProLink = null;
        }
      });
    },
    async getProList() {
      await ApiService.getProApi().list().then((data) => {
        this.proList = data.data;
        if (this.proList.length > 0 && !this.selectedPro) {
          this.selectedPro = this.proList[0];
        }
        if (this.proList.length > 0) {
          this.prosDropDown = [];
          for (const pro of this.proList) {
            this.prosDropDown.push({value: pro, text: pro.title});
          }
        }
      });
    },
    async getProDates() {
      let promises = [];

      promises.push(ApiService.getProApi().listDates(this.selectedPro.id, this.$route.params.userId).then((data) => {
        this.proDates = data.data;
        if (this.proDates.length > 0 && !this.selectedProDate) {
          this.selectedProDate = this.proDates[0]['value'];
        } else {
          this.selectedProDate = null;
        }
      }));

      await Promise.all(promises);
    },
    async setData(){
      this.showAll = true;
      this.isLoading = true;
      let promises = [];

      promises.push(ApiService.getProfilApi().getUserDetail(this.$route.params.userId).then((data) => {
        if(data.data && data.data.fullName){
          this.observedUser = data.data;
          if (data.data.codePortefeuilles && data.data.codePortefeuilles.length > 0) {
            this.codePtf = [...data.data.codePortefeuilles.filter((ptf) => ptf !== '')];
            if (!this.selected) {
              this.selected = this.codePtf[0];
            }
          }
        }

        if (this.haveAccess(ApplicationsAccessEnum.APP_PRO_OF_OTHER)) {
          this.getProList().then(() => {
            if (this.selectedPro) {
              this.getProDates().then(() => {
                this.getProDetails();
              })
            }
          }, () => {});
        }
      }));

      promises.push(ApiService.getCommercialApi().getConnections(this.$route.params.userId).then((data) => {
        this.connectionsInfos = data.data;
      }));

      promises.push(ApiService.getParcourirApi().getPersonalMonitoringResult(this.$route.params.userId, this.selectedDateId).then((data) => {
        this.personalIndicators = data.data;
      }, () => {}));

      promises.push(
          ApiService.getCommercialApi().getCommercialsList(
              this.$route.params.userId,
              'agent'
          ).then((data) => {
            this.agents = data.data;
            if (this.agents.length > 0) {
              for (const agent of this.agents) {
                this.agentsDropDown.push({value: agent.id, text: agent.fullName});
              }
            }
          })
      );
      await Promise.all(promises);
    },
    goBack() {
      this.$router.push({name: "commercials_home"});
      this.isMobile ? this.$store.dispatch('showHeader',true):'';
    },
    addFavoriteCommercial(){
      ApiService.getParcourirApi().setFavoriteCommercials(this.observedUser.id);
      this.observedUser.isFavorite = !this.observedUser.isFavorite;
    },
    saveUserPro(forSign) {
      var dataToSend = JSON.parse(JSON.stringify(this.proData));
      this.isLoading = true;

      for (const userProUserProObjectives of dataToSend.userProUserProObjectives) {
        for (const userProObjectives of userProUserProObjectives.userProObjectives) {
          if (userProObjectives.agents.length === 0) {
            continue;
          }
          let goodAgents= [];
          for (const agent of userProObjectives.agents) {
            if (agent.id) {
              goodAgents.push(agent.id);
            } else {
              goodAgents.push(agent);
            }
          }
          userProObjectives.agents = goodAgents;
        }
      }

      if (forSign) {
        dataToSend.state = 'wait_sign';
      } else {
        dataToSend.state = 'draft';
      }
      ApiService.getProApi().patchUserPro(
          this.selectedPro.id,
          this.$route.params.userId,
          dataToSend
      ).then(() => {
        this.getProDetails().then(() => this.isLoading = false);
      }, () => {this.isLoading = false;})
    },
    sendSignedPro() {
      this.$bvModal.show('send_signed_pro_modal');
    },
    handleSignedProModal(value) {
      if (value === true) {
        if (!this.proSignedFile) {
          return;
        }
        this.isLoading = true;

        var dataToSend = JSON.parse(JSON.stringify(this.proData));

        for (const userProUserProObjectives of dataToSend.userProUserProObjectives) {
          for (const userProObjectives of userProUserProObjectives.userProObjectives) {
            if (userProObjectives.agents.length === 0) {
              continue;
            }
            let goodAgents= [];
            for (const agent of userProObjectives.agents) {
              if (agent.id) {
                goodAgents.push(agent.id);
              } else {
                goodAgents.push(agent);
              }
            }
            userProObjectives.agents = goodAgents;
          }
        }
        ApiService.getProApi().patchUserPro(
            this.selectedPro.id,
            this.$route.params.userId,
            { ...dataToSend, signedPro: this.proSignedFile, state: 'waiting' }
        ).then(() => {
          this.getProDetails().then(() => this.isLoading = false);
        }, () => {this.isLoading = false;})
      }
    },
    dropzoneSuccess(file, response){
      this.proSignedFile = response.id;
    },
    dropzoneError(){
      this.$bvToast.toast('Une erreur est survenu', {
        title: `erreur`,
        solid: true,
        variant: 'error',
        toaster: 'b-toaster-top-center'
      })
      this.$refs.myVueDropzone.removeAllFiles(true);
    },
    downloadUserProForSign(){
      ApiService.getProApi().downloadUserPro(this.selectedPro.id, this.$route.params.userId)
          .then((res) => {
            const newBlob = new Blob([res.data], { type: 'pdf' });

            if (window.navigator && (window.navigator).msSaveOrOpenBlob) {
              (window.navigator).msSaveOrOpenBlob(newBlob);
              return;
            }

            const data = window.URL.createObjectURL(newBlob);

            const link = document.createElement('a');
            link.href = data;
            link.download = 'pro.pdf';

            link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
            setTimeout(() => {
              window.URL.revokeObjectURL(data);
              link.remove();
            }, 100);
          });
    },
    handleModal(value) {
      if (value === true) {
        this.saveUserPro(true);
      }
    },
    showModal() {
      this.$bvModal.show('validate-for-sign-pro-modal');
    },
    getOrCreateParent(parents, parentLabel) {
      if (!parents.has(parentLabel)) {
        parents.set(parentLabel, {
          id: `parent:${parentLabel}`,
          label: parentLabel,
          isSection: true,
          children: [],
        });
      }
      return parents.get(parentLabel);
    },

    extractABC(obj, baseKey) {
      const row = obj && obj[baseKey] ? obj[baseKey] : null;
      if (!row) {
        return null;
      }

      const keyA = baseKey + '_a';
      const keyB = baseKey + '_b';
      const keyC = baseKey + '_c';

      return {
        a: row[keyA] ?? null,
        b: row[keyB] ?? null,
        c: row[keyC] ?? null,
        diff: row.diff ?? null,
      }
    },
  },
   watch: {
     $route() {
       if(this.$route.params.userId != null){
         this.currentId = this.$route.params.userId;
         this.isLoading = true;
         ApiService.getParcourirApi().getDates().then((data) => {
           this.dates = data.data;
           this.dates = this.dates.map((element) => { return {value: element.id, text: element.text, date: element.value} })
           if (this.dates.length > 0) {
             this.selectedDateId = this.dates[0].value;
             this.selectedDate = this.dates[0].date;
           }

           this.setData().then(() => this.isLoading = false);
         });
       } else {
         this.showAll = false;
       }
     },
     'selectedProDate' : function(){
       this.isLoading = true;
       this.getProDetails().then(() => {this.isLoading = false});
     },
     'selectedPro' : function(){
       this.isLoading = true;
       this.downloadLink = ApiService.getMediaApi().get(this.selectedPro.cgv.id);
       this.getProDates().then(() => {
         this.getProDetails().then(() => {this.isLoading = false});
       })
     },
     'selected' : function() {
       this.$store.dispatch('setCurrentCodePtf',this.selected);
       this.isLoading = true;
       this.setData().then(() => this.isLoading = false);
     },
     'selectedDateId' : function() {
       this.isLoading = true;
       this.dates.forEach(date => {
         if (date.value === this.selectedDateId) {
           this.selectedDate = date.date;
         }
       })
       this.setData().then(() => this.isLoading = false);
     }
  }
};
</script>
